import { useRef } from 'react';
import { DynamicFormContainer } from '../DynamicFormContainer';
import { DynamicFormReducerActionType } from '../state/actions';
import { useResponsive } from '../../../hooks/useResponsive';

const scrollTop = () => {
  window.scrollTo(0, 0);
};

const mobileNavigationBarOffset = -34;

export const useStepper = () => {
  const stepperRef = useRef<HTMLDivElement>(null);
  const isMobile = useResponsive();
  const { dispatch, state } = DynamicFormContainer.useContainer();

  const scrollStart = () => {
    if (!isMobile) return;
    stepperRef.current
      ? window.scrollTo({ top: stepperRef.current.offsetTop + mobileNavigationBarOffset })
      : scrollTop();
  };

  const handleNext = () => {
    dispatch({
      type: DynamicFormReducerActionType.SET_NEXT_STEP,
    });
    scrollStart();
  };

  const handleBack = () => {
    dispatch({
      type: DynamicFormReducerActionType.SET_BACK_STEP,
    });
    scrollStart();
  };

  const handleReset = () => {
    dispatch({
      type: DynamicFormReducerActionType.SET_ACTIVE_STEP,
      payload: 0,
    });
    scrollStart();
  };

  const handleSetActiveStep = (index: number) => {
    dispatch({
      type: DynamicFormReducerActionType.SET_ACTIVE_STEP,
      payload: index,
    });
    scrollStart();
  };

  return { activeStep: state.activeStep, handleNext, handleReset, handleBack, handleSetActiveStep, stepperRef };
};
